import React from "react";
import { Card, Title, Text, Group, Badge, Stack, Divider, Button } from "@mantine/core";
import MCarousel from "components/MCarousel.jsx";
import { MSIcon } from "components/MSIcon.jsx";
import getLocalizedField from "services/getLocalizedField.js";
import { useTrans } from "core/index.js";
import MMaps from "../../../components/MMaps.jsx";

export default function ApartmentView({ apt, buttonLabel, closeLabel, onAction, onCancel, type }) {
	const { t } = useTrans();
	const images = apt.images || [];

	return (
		<Card shadow="md" radius="md" withBorder>
			{type !== "book" && apt.status === "unacceptable" && (
				<Group justify="space-between" style={{ "padding-bottom": "20px" }}>
					<Title order={2}>{t("apartment.requermient")}: </Title>

					<Text size="md" c="red">
						{apt.requirements}
					</Text>
					<Divider my="sm" />
				</Group>
			)}
			<MCarousel images={images} height={400} />
			<Stack mt="md">
				<Group justify="space-between">
					<Title order={2}>{getLocalizedField(apt, "name")}</Title>
					<Badge color="green" size="lg">
						{t(`customApartment.${apt.status}`)}
					</Badge>
				</Group>

				<Text size="md" c="dimmed">
					{getLocalizedField(apt, "desc")}
				</Text>

				<Divider my="sm" />

				<Text size="md" c="dimmed">
					{getLocalizedField(apt, "specifications")}
				</Text>
				<Divider my="sm" />

				<Title order={3}>{t("features.features")}</Title>
				<Group mt={10}>
					{(apt.features || []).map((f) => (
						<Badge key={f.id} variant="light" size="xl" color="blue">
							{getLocalizedField(f, "name")}:{" "}
							{f.type === 2 ? (
								f.value
							) : f.value === 1 ? (
								<span className="inline-flex items-center align-middle">
									<MSIcon name="Check" />
								</span>
							) : (
								<span className="inline-flex items-center align-middle">
									<MSIcon name="Close" />
								</span>
							)}
						</Badge>
					))}
				</Group>

				<Divider my="sm" />

				<Title order={3}>{t("apartment.Location")}</Title>
				<Text>{getLocalizedField(apt.Region, "name")}</Text>

				<MMaps
					latitude={apt.location?.latitude}
					longitude={apt.location?.longitude}
					popupText={apt.name_en || apt.name_ar}
				/>

				<Button
					mt="sm"
					variant="light"
					color="blue"
					onClick={() => {
						const lat = apt.location?.latitude;
						const lng = apt.location?.longitude;
						if (lat && lng) {
							window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
						}
					}}
				>
					{t("apartment.OpenInGoogleMaps")}
				</Button>

				<Divider my="sm" />
				{type === "publish" && (
					<>
						<Title order={3}>{t("baseApartmentDetails.ownerApartment")}</Title>
						<Text>{apt.OwnerInfo?.name}</Text>
						<Text>{apt.OwnerInfo?.email}</Text>
					</>
				)}
				{type !== "own" && (
					<div className="flex flex-row justify-between">
						<Button onClick={onCancel}>{t(closeLabel)}</Button>
						<Button onClick={onAction}>{t(buttonLabel)}</Button>
					</div>
				)}
			</Stack>
		</Card>
	);
}
